import { render, staticRenderFns } from "./ImageItem.vue?vue&type=template&id=e22029be&scoped=true&"
import script from "./ImageItem.vue?vue&type=script&lang=js&"
export * from "./ImageItem.vue?vue&type=script&lang=js&"
import style0 from "./ImageItem.vue?vue&type=style&index=0&id=e22029be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22029be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VIcon,VImg})
